import React, {Component} from "react";
import {NavLink} from "react-router-dom";
import {User} from "../../classes/user";
import {connect} from "react-redux";

const countryMenuItems = [
    {link: '/countries/burundi', name: 'Burundi'},
    {link: '/countries/kenya', name: 'Kenya'},
    {link: '/countries/rwanda', name: 'Rwanda'},
    {link: '/countries/south-sudan', name: 'South Sudan'},
    {link: '/countries/tanzania', name: 'Tanzania'},
    {link: '/countries/uganda', name: 'Uganda'},
];

class Menu extends Component<{ user: User }> {

    menuItems = [
        {
            link: '/users',
            name: 'Users'
        },
        {
            link: '/roles',
            name: 'Roles'
        },
        {
            link: '/projects',
            name: 'Project'
        },
        {
            link: '/surveys',
            name: 'Survey'
        },
        {
            link: '/submissions',
            name: 'Submission'
        }
    ]

    render() {

        let menu: JSX.Element[] = [];
        const userCountry = (this.props.user.country || '').trim().toLowerCase();
        const countries = countryMenuItems.filter(item => item.name.toLowerCase() === userCountry);

        this.menuItems.forEach(item => {
            if (this.props.user.canView(item.name.toLowerCase())) {
                menu.push(
                    <li className="nav-item">
                        <NavLink to={item.link} className="nav-link">
                            {item.name}
                        </NavLink>
                    </li>
                );
            }
        });

        return (
            <nav id="sidebarMenu" className="col-md-3 col-lg-2 d-md-block bg-light collapse show">
                <div className="sidebar-sticky pt-3">
                    <ul className="nav flex-column flex-nowrap overflow-hidden">
                        <li className="nav-item">
                            <NavLink to={'/dashboard'} className="nav-link">
                                Dashboard
                            </NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink to={'/scoreboard'} className="nav-link">
                                Scoreboard
                            </NavLink>
                        </li>
                        {countries.length > 0 && (
                            <>
                                <li className="nav-item">Countries</li>
                                {countries.map(item => (
                                    <li className="nav-item" key={item.link}>
                                        <NavLink to={item.link} className="nav-link">
                                            {item.name}
                                        </NavLink>
                                    </li>
                                ))}
                            </>
                        )}
                        Data Management
                        {menu}
                    </ul>
                </div>
            </nav>
        )
    }

}


// @ts-ignore
export default connect(state => ({user: state.user}))(Menu);
